import React from 'react';
import { ChevronLeft, ChevronRight, Store, DollarSign, Tag, Award, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';

export default function VendorCarousel() {
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const advertisementSlides = [
    {
      id: '1',
      title: 'Become a Featured Vendor',
      description: 'Reach thousands of gas station owners looking for quality service providers',
      icon: <Store className="w-12 h-12" />,
      backgroundColor: 'from-blue-600 to-blue-800',
      stats: [
        { value: '95%', label: 'Industry Focus' },
        { value: '3x', label: 'Higher Conversion Rate' },
        { value: '1000+', label: 'Monthly Users' }
      ],
      ctaText: 'Learn More About Sponsorship'
    },
    {
      id: '2',
      title: 'Premium Partner Program',
      description: 'Category exclusivity and preferred placement for early partners',
      icon: <Award className="w-12 h-12" />,
      backgroundColor: 'from-blue-600 to-blue-800',
      stats: [
        { value: '250+', label: 'Gas Station Operators' },
        { value: '24/7', label: 'Brand Visibility' },
        { value: 'No.1', label: 'Industry Platform' }
      ],
      ctaText: 'Join Premium Partners'
    },
    {
      id: '3',
      title: 'Showcase Your Products',
      description: 'Targeted advertising space for industry-specific products and services',
      icon: <Tag className="w-12 h-12" />,
      backgroundColor: 'from-blue-600 to-blue-800',
      stats: [
        { value: '$8M+', label: 'Avg. Transaction Size' },
        { value: '40%', label: 'Decision-Makers' },
        { value: '75%', label: 'Return Rate' }
      ],
      ctaText: 'Get Your Ad Featured'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === advertisementSlides.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? advertisementSlides.length - 1 : prev - 1
    );
  };

  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-blue-600 to-blue-800 text-white p-5 mb-4">
      <div className="carousel-container relative h-64">
        {advertisementSlides.map((ad, index) => (
          <motion.div
            key={ad.id}
            className={`absolute inset-0 bg-gradient-to-r ${ad.backgroundColor} text-white`}
            initial={{ opacity: 0 }}
            animate={{ opacity: index === currentSlide ? 1 : 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex flex-col items-center justify-center h-full p-5 text-center">
              <div className="mb-2">{ad.icon}</div>
              <h3 className="text-2xl font-bold mb-2">{ad.title}</h3>
              <p className="text-base mb-3 max-w-2xl">{ad.description}</p>
              
              <div className="grid grid-cols-3 gap-4 w-full max-w-3xl mb-3">
                {ad.stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div className="text-2xl font-bold mb-1">{stat.value}</div>
                    <div className="text-xs">{stat.label}</div>
                  </div>
                ))}
              </div>
              
              <button className="bg-white text-blue-800 px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-colors mt-4">
                {ad.ctaText}
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 hover:bg-white transition-colors"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 hover:bg-white transition-colors"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {advertisementSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-colors ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}